import React from 'react'

import { DeclineTemplate } from '@components/BonusSystemCommon'
import { buildAtlasImageStyles } from '@utils/buildAtlasImageStyles'
import { useBuyBonusStore } from '@stores/buyBonusStore'
import { useFreeBuyBonusStore } from '@stores/freeBuyBonusStore'
import { DeclineBonusInfo, DeclineBonusStyles } from '@components/BonusSystemCommon/content/DeclineTemplate'
import { Bonus } from 'game-ui-types'
import { useTranslation } from '@amusnet/translations/react'

interface FBBDeclineProps {
    bonus?: Bonus
}

const FBBDecline: React.FC<FBBDeclineProps> = ({ bonus }) => {
    const findElementByImageName = useBuyBonusStore((state) => state.findElementByImageName)
    const cachedImages = useBuyBonusStore((state) => state.cachedImages)

    const styles = useFreeBuyBonusStore((state) => state.styles)

    const { t } = useTranslation()

    const freeBonusNameText = t('gameui.bonusSystem.freeBonusName', {
        bonusName: bonus?.typeConfiguration?.freeBuyBonusConfiguration?.label ?? '',
    })

    const bonusInfo: DeclineBonusInfo | undefined = bonus && {
        betValue: bonus.betValue,
        bundleDetails: [
            {
                text: freeBonusNameText,
                styles: 'text-4xl font-black leading-[2.2]',
            },
        ],
    }

    const image =
        bonus &&
        bonus.typeConfiguration!.freeBuyBonusConfiguration!.imageName &&
        findElementByImageName(bonus.typeConfiguration!.freeBuyBonusConfiguration!.imageName)
    const stylesConfig: DeclineBonusStyles = {
        primaryTextColor: styles.primaryTextColor,
        secondaryTextColor: styles.secondaryTextColor,
        background: styles.bodyBackground,
        imageStyles: image
            ? buildAtlasImageStyles(image.atlasName, image.value, cachedImages[image.atlasName])
            : undefined,
    }

    return <DeclineTemplate bonusInfo={bonusInfo} styles={stylesConfig} />
}

export default FBBDecline
